// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Variables específicas del modal */
    --color-border: var(--color-borders); /* Modificado para usar la variable global */
    --color-hover-send: #258557;
    --color-hover-edit: #d53232;
    --color-hover-cancel: #ea6100;
    --color-hover-back: #4338ca;
}

/* ESTILOS DEL MODAL */
.modal-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5); 
    backdrop-filter: blur(2px);
}

.modal-content {
    padding: 30px;
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    margin: 20px;
    min-width: 800px;
    overflow: hidden;
    
    /* Adaptacion para Dark Mode */
    background-color: var(--bg-card);
    color: var(--texto-principal);
    border: 1px solid var(--color-borders);
}

/* Encabezado */
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--color-border);
    padding-bottom: 15px;
    margin-bottom: 20px;
}

.modal-header h3 {
    margin: 0;
    font-size: 1.5rem;
    color: var(--texto-principal);
    font-weight: 600;
}

.modal-close-button {
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
    color: var(--color-gray-text);
    transition: color 0.2s;
}

.modal-close-button:hover {
    color: var(--texto-principal);
}

/* Cuerpo */
.modal-body {
    flex-grow: 1;
    overflow-y:auto;
}

.mail-subject-input {
    width: 90%;
    padding: 12px;
    margin-bottom: 15px;
    
    border: 1px solid var(--color-border);
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    
    background-color: var(--bg-input);
    color: var(--texto-principal);
    
    /* Si es un input, quitamos el outline feo al hacer click */
    outline: none;
    transition: border-color 0.2s;
}

.mail-subject:focus {
    border-color: var(--primary-blue);
}

.mail-textarea {
    width: 94%;
    min-height: 200px;
    padding: 20px;
    resize: vertical;
    border: 1px solid var(--color-border);
    border-radius: 8px;
    line-height: 1.7;
    font-size: 1rem;
    transition: all 0.3s ease;
    background-color: var(--color-light-bg);
    color: var(--color-gray-text);
    cursor: default;

}

.mail-textarea--editing {
    background-color: var(--bg-input); /* Usamos la variable de inputs */
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(80, 56, 237, 0.2);
    color: var(--texto-principal);
    cursor: text;
}

/* Footer */
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    padding: 20px 30px;
    margin: 0 -30px -30px -30px;
    border-top: 1px solid var(--color-border);
    margin-top: 25px;

    background-color: transparent; 
}

.modal-footer.footer-selection {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
    justify-content: center;
    background-color: transparent; /* Transparente para evitar franja blanca */

}

.modal-button {
    padding: 12px 20px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    font-weight: 600;
    color: white;
}

.modal-button:active:not(:disabled) {
    transform: translateY(1px);
}

.modal-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
    transform: none;
}

/* Botones */
.modal-button--send {
    background-color: var(--score-verde);
}

.modal-button--send:hover:not(:disabled) {
    background-color: var(--color-hover-send);
}

.modal-button--edit {
    background-color: var(--score-rojo);
}

.modal-button--edit:hover:not(:disabled) {
    background-color: var(--color-hover-edit);
}

.modal-button--back {
    background-color: var(--primary-blue);
}

.modal-button--back:hover:not(:disabled) {
    background-color: var(--color-hover-back);
}

.modal-button--cancel {
    background-color: var(--score-naranja);
}

.modal-button--cancel:hover:not(:disabled) {
    background-color: var(--color-hover-cancel);
}

/* Mensaje error */
.error-message {
    color: var(--score-rojo);
    background-color: rgba(239, 68, 68, 0.1);
    border: 1px solid var(--score-rojo);
    padding: 10px 15px;
    border-radius: 6px;
    margin-bottom: 15px;
    font-weight: 500;
}

/* Selección de formato */
.format-selection-container {
    display: flex;
    flex-direction: column;
    gap: 20px;

}

.format-selection-container h3 {
    text-align: center;
    color: var(--primary-blue);
}

.selection-description {
    text-align: center;
    color: var(--color-gray-text);
    font-style: italic;
}

.format-options {
    display: flex;
    gap: 50px;
    padding: 15px 0;
    justify-content: center;

}

.format-card {
    background-color: var(--color-light-bg);
    border: 2px solid var(--color-light-bg);
    border-radius: 10px;
    padding: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);

}

.format-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.format-card h4 {
    margin-top: 0;
    font-size: 1.15rem;
    font-weight: 600;
    color: var(--texto-principal);
}

.format-card p {
    font-size: 0.9rem;
    color: var(--color-gray-text);
    line-height: 1.5;
}

.format-card.formal-format:hover {
    border-color: var(--primary-blue);
}

.format-card.intermedio-format:hover {
    border-color: var(--score-verde);
}

.format-card.informal-format:hover {
    border-color: var(--score-naranja);
}

.modal-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Override para dark mode en loading */
body.dark-mode .modal-loading-overlay {
    background: rgba(0, 0, 0, 0.8);
}

.format-card--disabled {
    opacity: 0.6; 
    cursor: not-allowed !important; /* Cambia el cursor para indicar inactividad */
    pointer-events: none; /* Evita que el mouse interactúe con el elemento (doble seguridad) */
    /* ANULA EL HOVER */
    transform: none !important; /* Deshabilita la elevación (translateY) */
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important; 
    border-color: var(--color-light-bg) !important; /* Elimina el borde de color del hover */
}

/* Etiquetas */
.format-info {
    margin-bottom: 10px;
    font-size: 1rem;
    color: var(--color-gray-text);
}

.format-tag {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 700;
    margin-left: 8px;
    color: white;
}

.format-tag--formal {
    background-color: var(--primary-blue);
}

.format-tag--intermedio {
    background-color: var(--score-verde);
}

.format-tag--informal {
    background-color: var(--score-naranja);
}`, "",{"version":3,"sources":["webpack://./src/components/ModalCorreo/modalCorreo.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,oCAAoC,EAAE,4CAA4C;IAClF,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;;IAEhB,8BAA8B;IAC9B,gCAAgC;IAChC,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;;IAEnB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;;IAEhB,iCAAiC;IACjC,6BAA6B;;IAE7B,2DAA2D;IAC3D,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,uCAAuC;IACvC,6BAA6B;IAC7B,eAAe;;AAEnB;;AAEA;IACI,iCAAiC,EAAE,iCAAiC;IACpE,iCAAiC;IACjC,4CAA4C;IAC5C,6BAA6B;IAC7B,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,2BAA2B;IAC3B,yCAAyC;IACzC,gBAAgB;;IAEhB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,6BAA6B,EAAE,2CAA2C;;AAE9E;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,wCAAwC;IACxC,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;;AAEb;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;;AAE3B;;AAEA;IACI,uCAAuC;IACvC,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,0CAA0C;;AAE9C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,8BAA8B,EAAE,8CAA8C;IAC9E,oBAAoB,EAAE,oEAAoE;IAC1F,mBAAmB;IACnB,0BAA0B,EAAE,0CAA0C;IACtE,qDAAqD;IACrD,8CAA8C,EAAE,wCAAwC;AAC5F;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C","sourcesContent":[":root {\r\n    /* Variables específicas del modal */\r\n    --color-border: var(--color-borders); /* Modificado para usar la variable global */\r\n    --color-hover-send: #258557;\r\n    --color-hover-edit: #d53232;\r\n    --color-hover-cancel: #ea6100;\r\n    --color-hover-back: #4338ca;\r\n}\r\n\r\n/* ESTILOS DEL MODAL */\r\n.modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    background-color: rgba(0, 0, 0, 0.5); \r\n    backdrop-filter: blur(2px);\r\n}\r\n\r\n.modal-content {\r\n    padding: 30px;\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: 90vh;\r\n    margin: 20px;\r\n    min-width: 800px;\r\n    overflow: hidden;\r\n    \r\n    /* Adaptacion para Dark Mode */\r\n    background-color: var(--bg-card);\r\n    color: var(--texto-principal);\r\n    border: 1px solid var(--color-borders);\r\n}\r\n\r\n/* Encabezado */\r\n.modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px solid var(--color-border);\r\n    padding-bottom: 15px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.modal-header h3 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    color: var(--texto-principal);\r\n    font-weight: 600;\r\n}\r\n\r\n.modal-close-button {\r\n    background: none;\r\n    border: none;\r\n    font-size: 2rem;\r\n    cursor: pointer;\r\n    color: var(--color-gray-text);\r\n    transition: color 0.2s;\r\n}\r\n\r\n.modal-close-button:hover {\r\n    color: var(--texto-principal);\r\n}\r\n\r\n/* Cuerpo */\r\n.modal-body {\r\n    flex-grow: 1;\r\n    overflow-y:auto;\r\n}\r\n\r\n.mail-subject-input {\r\n    width: 90%;\r\n    padding: 12px;\r\n    margin-bottom: 15px;\r\n    \r\n    border: 1px solid var(--color-border);\r\n    border-radius: 8px;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    \r\n    background-color: var(--bg-input);\r\n    color: var(--texto-principal);\r\n    \r\n    /* Si es un input, quitamos el outline feo al hacer click */\r\n    outline: none;\r\n    transition: border-color 0.2s;\r\n}\r\n\r\n.mail-subject:focus {\r\n    border-color: var(--primary-blue);\r\n}\r\n\r\n.mail-textarea {\r\n    width: 94%;\r\n    min-height: 200px;\r\n    padding: 20px;\r\n    resize: vertical;\r\n    border: 1px solid var(--color-border);\r\n    border-radius: 8px;\r\n    line-height: 1.7;\r\n    font-size: 1rem;\r\n    transition: all 0.3s ease;\r\n    background-color: var(--color-light-bg);\r\n    color: var(--color-gray-text);\r\n    cursor: default;\r\n\r\n}\r\n\r\n.mail-textarea--editing {\r\n    background-color: var(--bg-input); /* Usamos la variable de inputs */\r\n    border-color: var(--primary-blue);\r\n    box-shadow: 0 0 0 3px rgba(80, 56, 237, 0.2);\r\n    color: var(--texto-principal);\r\n    cursor: text;\r\n}\r\n\r\n/* Footer */\r\n.modal-footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 15px;\r\n    padding: 20px 30px;\r\n    margin: 0 -30px -30px -30px;\r\n    border-top: 1px solid var(--color-border);\r\n    margin-top: 25px;\r\n\r\n    background-color: transparent; \r\n}\r\n\r\n.modal-footer.footer-selection {\r\n    border-top: none;\r\n    margin-top: 0;\r\n    padding-top: 0;\r\n    justify-content: center;\r\n    background-color: transparent; /* Transparente para evitar franja blanca */\r\n\r\n}\r\n\r\n.modal-button {\r\n    padding: 12px 20px;\r\n    border: none;\r\n    border-radius: 30px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    color: white;\r\n}\r\n\r\n.modal-button:active:not(:disabled) {\r\n    transform: translateY(1px);\r\n}\r\n\r\n.modal-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n    transform: none;\r\n}\r\n\r\n/* Botones */\r\n.modal-button--send {\r\n    background-color: var(--score-verde);\r\n}\r\n\r\n.modal-button--send:hover:not(:disabled) {\r\n    background-color: var(--color-hover-send);\r\n}\r\n\r\n.modal-button--edit {\r\n    background-color: var(--score-rojo);\r\n}\r\n\r\n.modal-button--edit:hover:not(:disabled) {\r\n    background-color: var(--color-hover-edit);\r\n}\r\n\r\n.modal-button--back {\r\n    background-color: var(--primary-blue);\r\n}\r\n\r\n.modal-button--back:hover:not(:disabled) {\r\n    background-color: var(--color-hover-back);\r\n}\r\n\r\n.modal-button--cancel {\r\n    background-color: var(--score-naranja);\r\n}\r\n\r\n.modal-button--cancel:hover:not(:disabled) {\r\n    background-color: var(--color-hover-cancel);\r\n}\r\n\r\n/* Mensaje error */\r\n.error-message {\r\n    color: var(--score-rojo);\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    border: 1px solid var(--score-rojo);\r\n    padding: 10px 15px;\r\n    border-radius: 6px;\r\n    margin-bottom: 15px;\r\n    font-weight: 500;\r\n}\r\n\r\n/* Selección de formato */\r\n.format-selection-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n\r\n}\r\n\r\n.format-selection-container h3 {\r\n    text-align: center;\r\n    color: var(--primary-blue);\r\n}\r\n\r\n.selection-description {\r\n    text-align: center;\r\n    color: var(--color-gray-text);\r\n    font-style: italic;\r\n}\r\n\r\n.format-options {\r\n    display: flex;\r\n    gap: 50px;\r\n    padding: 15px 0;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.format-card {\r\n    background-color: var(--color-light-bg);\r\n    border: 2px solid var(--color-light-bg);\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\r\n\r\n}\r\n\r\n.format-card:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.format-card h4 {\r\n    margin-top: 0;\r\n    font-size: 1.15rem;\r\n    font-weight: 600;\r\n    color: var(--texto-principal);\r\n}\r\n\r\n.format-card p {\r\n    font-size: 0.9rem;\r\n    color: var(--color-gray-text);\r\n    line-height: 1.5;\r\n}\r\n\r\n.format-card.formal-format:hover {\r\n    border-color: var(--primary-blue);\r\n}\r\n\r\n.format-card.intermedio-format:hover {\r\n    border-color: var(--score-verde);\r\n}\r\n\r\n.format-card.informal-format:hover {\r\n    border-color: var(--score-naranja);\r\n}\r\n\r\n.modal-loading-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    z-index: 9999;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n/* Override para dark mode en loading */\r\nbody.dark-mode .modal-loading-overlay {\r\n    background: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.format-card--disabled {\r\n    opacity: 0.6; \r\n    cursor: not-allowed !important; /* Cambia el cursor para indicar inactividad */\r\n    pointer-events: none; /* Evita que el mouse interactúe con el elemento (doble seguridad) */\r\n    /* ANULA EL HOVER */\r\n    transform: none !important; /* Deshabilita la elevación (translateY) */\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important; \r\n    border-color: var(--color-light-bg) !important; /* Elimina el borde de color del hover */\r\n}\r\n\r\n/* Etiquetas */\r\n.format-info {\r\n    margin-bottom: 10px;\r\n    font-size: 1rem;\r\n    color: var(--color-gray-text);\r\n}\r\n\r\n.format-tag {\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    font-size: 0.85rem;\r\n    font-weight: 700;\r\n    margin-left: 8px;\r\n    color: white;\r\n}\r\n\r\n.format-tag--formal {\r\n    background-color: var(--primary-blue);\r\n}\r\n\r\n.format-tag--intermedio {\r\n    background-color: var(--score-verde);\r\n}\r\n\r\n.format-tag--informal {\r\n    background-color: var(--score-naranja);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
